import { LEGACY_ACTIONS_BUCKET_A } from './taxonomyBuckets';

/** When autocapture is on, bucket (a) hand `UserAction` calls are suppressed (PATHWAY-4099). */
export const shouldSuppressLegacyUserActionWhenAutocaptureEnabled = (
  action: string,
  amplitudeAutocaptureEnabled: boolean,
): boolean => {
  if (!amplitudeAutocaptureEnabled) {
    return false;
  }
  return (LEGACY_ACTIONS_BUCKET_A as readonly string[]).includes(action);
};
